import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch } from 'react-router-dom';

import { useAuthenticatedUser } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Container, Jumbo, Tabs, tokens } from '@treams/treams-ui';

import Jobs from '../../../../../../src/job/Jobs';
import CurrentlyViewedUserContext from '../../../../../../src/packages/kakapo-ui-application/contexts/CurrentlyViewedUserContext';
import LearningEventModalID from '../../../../../../src/packages/kakapo-ui-application/pages/learning/pages/LearningEventModal';
import JourneyListContainer from './JourneyListContainer';

const CONTENT_WIDTH = 1000;

export default function Journey(props: { userID?: string; jumbo?: boolean }) {
	const { t } = useTranslation();

	const viewer = useAuthenticatedUser();
	const query = graphql.useUserQuery({ variables: { id: props.userID ?? viewer.id } });

	if (!query.data) {
		return null;
	}

	return (
		<>
			{props.jumbo !== false && (
				<Jumbo
					title={`${query.data.user.firstName} ${query.data.user.lastName}`}
					wide={CONTENT_WIDTH}
					footer={
						<Tabs.Container wide={CONTENT_WIDTH}>
							{query.data.user.viewerCanViewJourney && (
								<Tabs.Item
									path={props.userID ? `/users/${props.userID}/journey` : `/journey`}
									title={t('journey.tabs.journey')}
								/>
							)}
							<Tabs.Item
								path={props.userID ? `/users/${props.userID}/journey/jobs` : `/journey/jobs`}
								title={t('journey.tabs.jobs')}
							/>
						</Tabs.Container>
					}
				/>
			)}
			<Switch>
				<Route
					path={[
						'/users/:id/journey',
						'/journey',
						'/users/:userID/journey/learning/:ID',
						'/journey/learning/:id',
					]}
					exact
				>
					{query.data.user.viewerCanViewJourney ? (
						<Container wide={CONTENT_WIDTH} mt={`${tokens.gap.page}px`} mb={`${tokens.gap.page}px`}>
							<CurrentlyViewedUserContext.Provider
								value={{
									currentlyViewedUser: query.data.user as graphql.User,
								}}
							>
								<JourneyListContainer user={query.data.user as graphql.User} />
							</CurrentlyViewedUserContext.Provider>

							<Route path={['/users/:userID/journey/learning/:ID', '/journey/learning/:id']}>
								{({ match }) =>
									match && (
										<LearningEventModalID
											eventID={(match.params as { id: string }).id!}
											returnURL={props.userID ? `/users/${props.userID}/journey` : '/journey'}
										/>
									)
								}
							</Route>
						</Container>
					) : (
						<Redirect to={`/users/${query.data.user.id}/journey/jobs`} />
					)}
				</Route>
				<Route path={['/users/:id/journey/jobs', '/journey/jobs']}>
					<Container wide={CONTENT_WIDTH} py={4}>
						<Jobs userID={query.data.user.id} />
					</Container>
				</Route>
			</Switch>
		</>
	);
}
